import React from "react";
import { noop } from "@common/helpers/function";
import { RuleActionType } from "@common/types/transactionRule";
import {
    FilterMultiselect,
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { useIsGlFirst } from "@hooks/useIsGlFirst";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { BaseFilterProps, ruleActionDisplayLabels } from "../../lib";

export const ruleActionFilterOptions: RuleActionType[] = [
    RuleActionType.CATEGORY,
    RuleActionType.ENTITY,
    RuleActionType.ACCOUNT_ID,
    RuleActionType.ACCRUAL_ACCOUNT_ID,
    RuleActionType.MEMO,
    RuleActionType.COUNTERPARTY,
    RuleActionType.CUSTOMER,
    RuleActionType.CLASS,
    RuleActionType.ASSIGN_TO_SCHEDULE,
];

const isRuleActionType = (
    value: FilterMultiselectValue,
): value is RuleActionType =>
    Object.values(RuleActionType).some((actionType) => actionType === value);

export const RuleActionFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const { enabled: isGlFirst } = useIsGlFirst();
    const { schedules } = useTypedFlags();

    const options: FilterMultiselectOption[] = ruleActionFilterOptions
        .filter(
            (actionType) =>
                !isGlFirst || actionType !== RuleActionType.CATEGORY,
        )
        .filter(
            (actionType) =>
                schedules || actionType !== RuleActionType.ASSIGN_TO_SCHEDULE,
        )
        .map((actionType) => ({
            value: actionType,
            label: ruleActionDisplayLabels[actionType],
            searchableLabel: ruleActionDisplayLabels[actionType],
        }));

    return (
        <FilterMultiselect
            inDropdown={false}
            searchable={false}
            options={options}
            value={filters.ruleActionTypes ?? []}
            onChange={(val) => {
                onChange({
                    ruleActionTypes: val.filter(isRuleActionType),
                });
            }}
            name="ruleActionTypes"
            onBlur={noop}
        />
    );
};
